import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { AuthenticateUserResponse, Token } from '@domain/entities';
import { AuthRepository } from '@domain/repositories';
import { AuthService } from '../api-clients/auth.service';
import { AuthenticateUserResponseDTO } from '../dtos/auth.dto';
import { AuthMapper } from '../mappers/auth.mapper';
import { MasterTokenMapper } from '../mappers/token.mapper';

@Injectable()
export class AuthRepositoryImpl implements AuthRepository {
  private readonly _masterTokenMapper = new MasterTokenMapper();
  private readonly _authMapper = new AuthMapper();

  constructor(private readonly _authService: AuthService) {}

  login(): Observable<Token> {
    const tokenDto = this._authService.login();
    return tokenDto.pipe(
      map(tokenDto => this._masterTokenMapper.toDomain(tokenDto))
    );
  }

  getMasterToken(): Observable<Token> {
    const tokenDto = this._authService.getMasterToken();
    return tokenDto.pipe(
      map(tokenDto => this._masterTokenMapper.toDomain(tokenDto))
    );
  }

  authenticateUser(): Observable<AuthenticateUserResponse> {
    const authenticateUserResponseDto = this._authService.authenticateUser();
    return authenticateUserResponseDto.pipe(
      map(dto =>
        this._authMapper.authenticateUserToDomain(
          dto as unknown as AuthenticateUserResponseDTO
        )
      )
    );
  }
}
